<template>
  <div class="lpaymentApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="infoCon">
      <h2>路线行程</h2>
      <el-timeline>
        <el-timeline-item timestamp="起始端" placement="top" icon="el-icon-success" type="primary" color="#fff" size="large">
          <div class="initial">
            <h4>{{detail.initial.title}}</h4>
            <p>营业时间：{{detail.initial.business}}</p>
          </div>
        </el-timeline-item>
        <el-timeline-item timestamp="目的地" placement="top" icon="el-icon-success" type="primary" color="#fff" size="large">
          <div class="initial">
            <h4>{{setPurpose.title}}</h4>
            <p>{{setPurpose.address}}</p>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="pro">
      <div class="goods">
        <div class="left">
          <el-image style="width:100%;height:55px; border-radius:5px;" :src="baseUrl+detail.image[0]" fit="cover"></el-image>
        </div>
        <div class="right">
          <p>{{detail.title}}</p>
          <span style="padding-top:12px;color:#666;font-size:14px;display:block">×{{num}}件</span>
          <div class="price">
            <i>￥</i><b>{{detail.rate}}</b>
            <div>￥{{detail.price}}</div>
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="email">
        <span>送达时间</span>
        <input type="text" @click="drawer = true" :value="end >= 0 ? (detail.timer[start]+' '+startTimer[end]+'~'+endTimer[end]) : ''" readonly="readonly" placeholder="请选择送达时间">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="email">
        <span>联系人</span> 
        <input type="text" v-model="name" placeholder="请输入联系人">
      </div>
      <div class="email">
        <span>手机号码</span> 
        <input type="number" v-model="phone" placeholder="请输入手机号码">
      </div>
      <div class="email">
        <span>备注信息</span>
        <input type="text" v-model="remark" placeholder="请输入标注备注">
      </div>
    </div>
    <h2 class="payType">支付方式</h2>
    <div class="payMoney">
      <p @click="setPayType(1)" :class="payType == 1 ? 'curt' : ''">
        <img src="~assets/images/wx.png"/>
        微信支付
        <i class="el-icon-success"></i>
      </p>
      <p @click="setPayType(2)" :class="payType == 2 ? 'curt' : ''" style="line-height:50px;">
        <img src="~assets/images/zh.png"/>
        组合支付
        <i class="el-icon-success"></i>
      </p>
      <p @click="setPayType(3)" :class="payType == 3 ? 'curt' : ''">
        <img src="~assets/images/ye.png"/>
        <font>余额支付
        <em>￥{{setCash}}</em>
        </font>
        <i class="el-icon-success"></i>
      </p>
    </div>
    <div style="height:90px"></div>

    <div class="footer1">
      <div class="foot-title">
        <span>
          <i>￥</i><b>{{(detail.rate * num).toFixed(2)}}</b>
        </span>
        <span>共{{num}}件</span>
      </div>
      <div class="pay" @click="payment">
        <span>确认结算</span>        
      </div>
    </div>
    <el-drawer title="请选择取货时间" :visible.sync="drawer" size="60%" :direction="direction" :withHeader="true" :show-close="true" :wrapperClosable="false">
      <ul>
        <li>
          <p @click="start = i;end=-1" :class="i == start ? 'curt' : ''" v-for="(vo,i) in detail.timer">{{vo}}{{i == 0 ? '(今天)' : i == 1 ? '(明天)' : ''}}</p>
        </li>
        <li>
          <p @click="choose(i)" :style="end == i ? 'color:#ff4444' : ''" v-for="(vo,i) in startTimer" v-if="start == 0 && vo >= detail.dqtime">{{vo}} ~ {{endTimer[i]}} (配送约￥0.00)</p>
          <p @click="choose(i)" :style="end == i ? 'color:#ff4444' : ''" v-for="(vo,i) in startTimer" v-if="start > 0">{{vo}} ~ {{endTimer[i]}} (配送约￥0.00)</p>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        total:0,
        userData:[],
        setPurpose:[],
        remark:'',
        name:'',
        phone:'',
        num:1,
        start:0,
        end:-1,
        startTimer:[
          '06:00',
          '06:40',
          '07:20',
          '08:00',
          '08:40',
          '09:20',
          '10:00',
          '10:40',
          '11:20',
          '12:00',
          '12:40',
          '13:20',
          '14:00',
          '14:40',
          '15:20',
          '16:00',
          '16:40',
          '17:20',
          '18:00',
          '18:40',
          '19:20',
          '20:00',
          '20:40',
          '21:20',
        ],
        endTimer:[
          '06:40',
          '07:20',
          '08:00',
          '08:40',
          '09:20',
          '10:00',
          '10:40',
          '11:20',
          '12:00',
          '12:40',
          '13:20',
          '14:00',
          '14:40',
          '15:20',
          '16:00',
          '16:40',
          '17:20',
          '18:00',
          '18:40',
          '19:20',
          '20:00',
          '20:40',
          '21:20',
          '22:00',
        ],
        code:'',
        payType:1,
        setCash:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var id = this.$route.query.p
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/lpayment?p='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getDetail();
        this.getPurpose();
        this.getCash();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      choose:function(inx){
        this.end = inx;
        this.drawer =false;
      },
      setPayType:function(inx){
        var rate = this.detail.rate;
        var num = this.num;
        var setCash = this.setCash;
        if(setCash <= 0){
          this.$alert('您选择的支付方式账号余额不足！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if((rate * num >= setCash) && inx == 3){
          this.$alert('您账号余额不足够支付该订单，请您切换其他支付方式！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if((rate * num <= setCash) && inx == 2){
          this.$alert('您账号余额足够支付改订单，请您切换余额支付方式！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        this.payType = inx;
      },  
      getCash:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/user/cash',
          data:{
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            that.setCash = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getPurpose:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.p
        id = id.split('-')[2]
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/purposeDetail',
          data:{id:id},
          dataType:'json',
          success:function(data){
            that.setPurpose = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getDetail:function(){
        var that = this;
        that.fullscreenLoading = true
        var id = this.$route.query.p
        this.num = id.split('-')[3]
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/getLuggageDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.detail = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      payment:function(){
        var that = this;
        var id = this.$route.query.p;
        var start_id = id.split('-')[0];
        if(that.end < 0){
          that.$alert('请选择送达时间', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.name == ''){
          that.$alert('请输入姓名', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入输入手机号码', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/payment',
          data:{
            user_id:that.userData.id,
            name:that.name,
            phone:that.phone,
            remark:that.remark,
            num:that.num,
            l_id:that.detail.id,
            address:that.setPurpose.address,
            end_id:that.setPurpose.id,
            start_id:start_id,
            pay_type:that.payType,
            deliver_time:(that.detail.timer[that.start]+' '+that.startTimer[that.end]+'~'+that.endTimer[that.end])
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              if(that.payType == 3){
                window.location.href="http://user.4008005216.com/main/lorder";
              }else{
                that.callpay(data.data);
              }
              
            }else{
              that.$alert('支付失败，请重新确认信息后支付！', '提示', {
                confirmButtonText: '确定'
              });
            }
            that.fullscreenLoading = false;
          }
        })
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/lorder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },
      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getLuggage();
          that.getPurpose();
          that.getCash();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .lpaymentApp{
    max-width:640px;
    background:#F1F2F5;
    margin:0 auto;
  }

  .lpaymentApp .infoCon{
    background:#fff;
    margin-bottom:12px
  }
  .lpaymentApp .infoCon h2{
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding:15px 0
  }
  .lpaymentApp .infoCon .el-timeline{
    width:92%;
    margin:0 auto;
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item{
    padding-bottom: 12px;
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item__node{
    background:#fff;
    width:15px;
    height:15px;
    left:-3px
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item__node .el-icon-success{
    font-size:16px;
    color:#00A870;
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item__node .el-icon-error{
    font-size:16px;
    color:#E34D59;
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item__tail{
    border-color:#ccc;
    border-width:1px
  }
  .lpaymentApp .infoCon .el-timeline .el-timeline-item__timestamp{
    font-size:14px;
    color:#3C485C;
    padding-top:4px;
    margin-bottom:15px
  }
  .lpaymentApp .infoCon .el-timeline .initial{
    margin-bottom:4px;
    padding:10px;
    background:#F1F2F5;
    border-radius:6px;
    position: relative;
  }
  .lpaymentApp .infoCon .el-timeline .initial:last-child{
    margin-bottom:0;
    border-bottom:none
  }
  .lpaymentApp .infoCon .el-timeline .initial h4{
    padding-bottom:6px;
    color:#000;
    font-size:15px;
  }
  .lpaymentApp .infoCon .el-timeline .initial p{
    font-size:14px;
    color:#666
  }
  .lpaymentApp .pro{
    background:#fff;
    display:block;
    width:94%;
    border-radius: 6px;
    margin:0 auto;
  }
  .lpaymentApp .pro .bussTitle{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0px 0
  }
  .lpaymentApp .goods{
    margin-bottom:5px
  }
  .lpaymentApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .lpaymentApp .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    position: relative;
    min-height:60px;
  }
  .lpaymentApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%;
    font-weight:bold;
  }
  .lpaymentApp .goods .right p font{
    background:#f00;
    color:#fff;
    border-radius:5px;
    font-size:13px;
    position: relative;
    padding:2px;
    top:-2px;
    margin-right:2px
  }
  .lpaymentApp .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:13px;
  }
  .lpaymentApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .lpaymentApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .lpaymentApp .goods .right .price b{
    color: #f00;
    font-size:18px;
    font-weight:600;
  }

  .lpaymentApp .goods .right .price i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }
  
  .lpaymentApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .lpaymentApp textarea{
    display:block;
    width:calc(100% - 24px);
    border:none;
    font-size:15px;
    outline:none;
    vertical-align:top;
    background: #F1F2F5;
    resize: none;
    padding:12px;
    border-radius:6px;
    min-height:80px;
    margin-top:8px
  }

  .lpaymentApp .remark{
    display:block;
    width:94%;
    color:#999;
    font-size:14px;
    letter-spacing:1px;
    margin:0 auto;
    padding:10px 0 15px 0
  }

  .lpaymentApp .email{
    background:#fff;
    padding-bottom:12px;
    font-size:15px;
    color:#333;
    display:block;
    width:92%;
    margin:0 auto;
    position: relative;
    height:50px;
  }
  .lpaymentApp .email i{
    position: absolute;
    bottom:30px;
    right:2%
  }
  .lpaymentApp .email span{
    color:#333;
    font-size: 16px;
    float:left;
    font-weight:normal;
    width:20%;
    line-height:50px;
  }
  .lpaymentApp .email span.curt{
    background:#f00;
    color:#fff;
    padding:2px 5px;
    border-radius:5px;
  }
  .lpaymentApp .email input{
    float:left;
    width:calc(80% - 10px);
    border:none;
    font-size:15px;
    outline:none;
    vertical-align:top;
    background: #F1F2F5;
    resize: none;
    border-radius:6px;
    height:50px;
    padding-left:10px;
  }
  .lpaymentApp .email img{
    float:right;
    width:6px;
    margin-top:4px
  }

  .lpaymentApp .footer1{
    height: 45px;
    width: 92%;
    border-radius: 55px;
    position: fixed;
    bottom: 20px;
    left: 3%;
    z-index: 1
  }
  .lpaymentApp .footer1 .foot-title{
    float: left;
    width:65%;
    height:42px;
    background: #000;
    border-radius:40px 0 0 40px;
    padding-top:3px
  }
  .lpaymentApp .footer1 .foot-title span{
    font-size: 12px;
    color: #fff;
    margin-right:15px;
    display:block;
    margin-left:8%
  }
  .lpaymentApp .footer1 .foot-title span b{
    color: #fff;
    font-size:18px;
    font-weight:600;
  }

  .lpaymentApp .footer1 .foot-title span i{
    color: #fff;
    font-size:12px;
    font-style:normal
  }
  
  
  .lpaymentApp .footer1 .pay{
    float: right;
    width:35%
  }
  .lpaymentApp .footer1 .pay span{
    float:left;
    height:45px;
    line-height:45px;
    font-size: 15px;
    width:100%;
    color:#fff;
    text-align:center;
    font-weight:bold;
    background:#ff4444;
    border-radius:0 40px 40px 0;
  }
  .lpaymentApp .el-drawer{
    border-radius:20px 20px 0 0;
  }
  .lpaymentApp .el-drawer .el-drawer__header{
    margin-bottom:0px;
    color: #1C222B;
    font-size:18px;
    border-bottom:solid 1px #F1F2F5;
    padding-bottom:20px
  }
  .lpaymentApp .el-drawer .el-drawer__body{
  }
  .lpaymentApp .el-drawer .el-drawer__body ul{
    display: flex;
    height:100%
  }
  .lpaymentApp .el-drawer .el-drawer__body ul li:first-child{
    width:40%;
    background:#F1F2F5;
    text-align:center;
  }
  .lpaymentApp .el-drawer .el-drawer__body ul li:last-child{
    width:55%;
    margin-left:2.5%;
    height:100%;
    overflow-y: auto;
    overflow-x: clip;
    scrollbar-width: none;
  }
  .lpaymentApp .el-drawer .el-drawer__body ul li p{
    height:50px;
    line-height:50px;
    font-size:16px;
    justify-content:center;
    align-items:center;
  }
  .lpaymentApp .el-drawer .el-drawer__body ul li p.curt{
    background:#fff
  }
  .lpaymentApp .el-drawer .el-drawer__body ul li:last-child p{
    border-bottom:#F1F2F5 1px solid;
    font-size:14px
  }

  .lpaymentApp .el-drawer .el-drawer__body ul li:last-child p:last-child{
    border-bottom:0
  }
  .lpaymentApp .payType{
    width:94%;
    margin:0 auto;
    font-size:13px;
    color:#666;
    font-weight:normal;
    padding:15px 0 8px 0
  }
  .lpaymentApp .payMoney{
    width:94%;
    margin:0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .lpaymentApp .payMoney p{
    width:31.5%;
    background:#fff;
    font-size:14px;
    height:50px;
    border-radius: 6px;
  }
  .lpaymentApp .payMoney p:first-child{
    line-height:50px;
  }
  .lpaymentApp .payMoney p img{
    width:20px;
    float:left;
    margin:15px 6px 0 6px
  }
  .lpaymentApp .payMoney p font{
    float:left;
    width:50%;
    margin-top:12px
  }
  .lpaymentApp .payMoney p font em{
    font-style:normal;
    font-size:12px;
    color:#999
  }
  .lpaymentApp .payMoney p i{
    float:right;
    font-size:16px;
    color:#ddd;
    margin:17px 6px 0 0
  }

  .lpaymentApp .payMoney p.curt i{
    color:#ff4444
  }
</style>